import PaymentDueSummary from "./PaymentDueSummary";
import { useSelector, shallowEqual } from "react-redux";
import withRouter from "app/utils/hocs/withRouter";
import {
	getQuoteTotalWithDelta,
	getSavingsData,
	getSavingsDataHotelOnly,
	getTotalExcludedTaxes,
} from "app/pages/Booking/bookingSelectors";
import {
	calculatePartialPaymentAmount,
	getBookingPaymentMode,
	getPayNowAmount,
} from "app/pages/Booking/Payment/paymentSelector";

const mapStateToProps = (state, ownProps) => {
	const payAtPropertyAmount = getTotalExcludedTaxes(state);
	const total = getQuoteTotalWithDelta(state);
	const isHotelOnly = ownProps.isHotelOnly || ownProps.location.pathname.includes("/hotelonly/");
	const savingsData = isHotelOnly ? getSavingsDataHotelOnly(state) : getSavingsData(state);

	return {
		payNowAmount: getPayNowAmount(state),
		total,
		savingsTotalAmount: savingsData.amountSaved || 0,
		paymentMode: getBookingPaymentMode(state),
		mensualite2Fois: calculatePartialPaymentAmount(state),
		payAtPropertyAmount,
		isHotelOnly,
	};
};

const PaymentDueSummaryContainer = props => {
	const stateProps = useSelector(state => mapStateToProps(state, props), shallowEqual);
	return <PaymentDueSummary {...props} {...stateProps} />;
};

export default withRouter(PaymentDueSummaryContainer);
